module.exports = __webpack_public_path__ + "static/media/alarm1.ae85916d.mp3";